import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AssetAccountantSubscription } from '@assetaccountant/api/models/asset-accountant-subscription';
import { Register } from '@assetaccountant/core/models/register';
import { PeriodData, PeriodParams } from '@assetaccountant/core/resolvers/period.resolver';
import { OrganisationService } from '@assetaccountant/core/services/organisation.service';
import { RouteService } from '@assetaccountant/core/services/route.service';
import { SubscriptionService } from '@assetaccountant/core/services/subscription.service';
import {
  TypedActivatedRouteSnapshot,
  getChildRoute,
} from '@assetaccountant/core/utils/route-utils';

@Component({
  selector: 'app-settings-banner',
  templateUrl: './settings-banner.component.html',
  styleUrls: ['./settings-banner.component.scss'],
  standalone: false,
})
export class SettingsBannerComponent implements OnInit {
  isManaged = false;

  register?: Register;
  registers?: Register[];
  subscription?: AssetAccountantSubscription;

  get assetsLink() {
    return this.routeService.getAssetsRoute();
  }

  get demoLink() {
    return `${this.routeService.getLinkWithReplacedParameters(['organisations'])}/registers/${
      this.demoRegister?.id
    }`;
  }

  get demoRegister() {
    return this.registers?.find(r => r.isDemo);
  }

  get integrationName() {
    return this.register ? this.register.integrations.find(i => i.isPrimary)?.name : null;
  }

  // Shows when account is created via integration app store
  get showBanner() {
    return (
      !this.register?.isDemo &&
      this.subscription?.totalAssets === 0 &&
      this.register?.integrations.find(i => i.isPrimary)
    );
  }

  constructor(
    private router: Router,
    private organisationService: OrganisationService,
    private subscriptionService: SubscriptionService,
    private routeService: RouteService,
  ) {}

  ngOnInit() {
    const { register } = getChildRoute(
      this.router.routerState.snapshot.root as TypedActivatedRouteSnapshot<
        PeriodParams,
        PeriodData
      >,
    ).data;

    this.register = register;

    this.organisationService.listRegisters().subscribe(({ registers }) => {
      this.registers = registers;
    });

    this.subscriptionService.getSubscription().subscribe(result => {
      this.subscription = result;
    });
  }
}
